{
  "unused_sku": {
    "message": "No product was found for SKU \"{sku}\". You can still create pricing for it.",
    "action": "Create pricing for SKU {sku}"
  },
  "variant_summary": {
    "title": "Variant Summary",
    "view_in_platform": "View product in {platform}",
    "variant": "Variant"
  },
  "price_list_pricing_card": {
    "not_editable": "This is an automated price list and cannot be edited. You can make changes from the price lists area.",
    "manage_link": "Manage price lists",
    "empty": "No pricing has been uploaded for this product. Add pricing by selecting a price list below or via the Price Lists area.",
    "add_price": "Add a new price",
    "headings": {
      "quantity": "Quantity",
      "unit_of_measure": "Unit of measure",
      "price": "Price",
      "actions": "Actions"
    },
    "errors": {
      "duplicate_quantity": "A price with this quantity already exists. Please remove the existing price or change the quantity.",
      "unit_of_measure_needs_quantity_one": "Base price for this item has quantity above 1. Unit of measure cannot be used."
    }
  },
  "add_price_list": {
    "label": "Select a Price List",
    "button": "Add price list",
    "none_available": "All price lists have been assigned",
    "note": "Please note: you can only choose from existing price lists.",
    "manage_link": "Manage price lists"
  },
  "price_row": {
    "edit": "Edit",
    "remove": "Remove",
    "save": "Save",
    "cancel": "Cancel",
    "quantity": "Quantity",
    "price": "Price",
    "unit_of_measure": "Unit of measure",
    "unit_of_measure_placeholder": "e.g. pallet-box",
    "errors": {
      "quantity": "Quantity must be a whole number of 1 or more.",
      "price": "Enter a valid price.",
      "unit_of_measure": "Unit of measure is required.",
      "unit_of_measure_pattern": "Unit of measure can only contain letters, numbers and dashes."
    }
  },
  "remove_price_modal": {
    "title": "Remove price",
    "message": "Are you sure you want to remove this price from this product?",
    "confirm": "Remove"
  },
  "remove_price_list_modal": {
    "title": "Remove price list",
    "message": "Are you sure you want to remove the \"{slug}\" price list from this product? Please note, if you want to fully delete a price list, you can do so from the \"Price List\" area.",
    "confirm": "Remove"
  },
  "manual_lists_note": {
    "text": "Please note: you can only edit pricing for manually uploaded price lists."
  }
}
